import { client } from "./axiosClient";

const BASE_URL = "api/governance/sessions/";

export async function getSessions() {
  const response = await client.get(BASE_URL);
  return response.data;
}

export async function getSession(sessionId) {
  const response = await client.get(`${BASE_URL}${sessionId}/`);
  return response.data;
}

export async function createSession(sessionData) {
  const response = await client.post(BASE_URL, sessionData);
  return response.data;
}

export async function updateSession(sessionId, sessionData) {
  const response = await client.put(`${BASE_URL}${sessionId}/`, sessionData);
  return response.data;
}

export async function deleteSession(sessionId) {
  const response = await client.delete(`${BASE_URL}${sessionId}/`);
  return response.data;
}

export async function activateSession(sessionId) {
  const response = await client.post(`${BASE_URL}${sessionId}/activate/`);
  return response.data;
}

export async function updateSessionPages(sessionId, pages) {
  const response = await client.patch(`${BASE_URL}${sessionId}/`, { pages });
  return response.data;
}

export async function getSessionMessages(sessionId) {
  const response = await client.get(`${BASE_URL}${sessionId}/messages/`);
  return response.data;
}

export async function createSessionMessage(sessionId, messageData) {
  const response = await client.post(
    `${BASE_URL}${sessionId}/messages/`,
    messageData,
  );
  return response.data;
}

export async function updateSessionMessage(sessionId, messageId, messageData) {
  const response = await client.put(
    `${BASE_URL}${sessionId}/messages/${messageId}/`,
    messageData,
  );
  return response.data;
}

export async function deleteSessionMessage(sessionId, messageId) {
  const response = await client.delete(
    `${BASE_URL}${sessionId}/messages/${messageId}/`,
  );
  return response.data;
}

// P&L Metadata - uses existing endpoint from PLExplorer
export async function getPnlMetadata() {
  const response = await client.post("api/results_pl_explorer_meta/");
  return response.data;
}

// P&L Values - reads actual P&L data for a given period
export async function getPnlValues(params) {
  const response = await client.post(
    "api/results_pl_explorer_read_pl/",
    params,
  );
  return response.data;
}

// Overview Data - monthly volume, revenue, and serve margin for charts
export async function getOverviewData(referenceYear, referenceMonth) {
  const response = await client.post("api/alignment_session/overview_data/", {
    reference_year: referenceYear,
    reference_month: referenceMonth,
  });
  return response.data;
}

// Trends Drivers - reuses existing Trends endpoint for margin driver analysis
export async function getDriversData(params) {
  const response = await client.post("api/results_trends_drivers/", params);
  return response.data;
}

// Top Elements Data - ranking, cascade, mix for Top Clients/Products pages
export async function getTopElementsData(params) {
  const response = await client.post(
    "api/alignment_session/top_elements_data/",
    params,
  );
  return response.data;
}

// Element Detail Data - P&L + mix for a specific element (on-demand)
export async function getElementDetailData(params) {
  const response = await client.post(
    "api/alignment_session/top_elements_data/",
    params,
  );
  return response.data;
}

// Initiatives Data - reuses existing action plans endpoint
export async function getInitiativesData() {
  const response = await client.post("api/action_plans_initiatives/");
  return response.data;
}

// Cascade Drilldown - per-element data for a specific cascade node
export async function getCascadeDrilldownData(params) {
  const response = await client.post(
    "api/alignment_session/cascade_drilldown/",
    params,
  );
  return response.data;
}

// Dimension Data - breakdown by dimension for By Dimension page
export async function getDimensionData(params) {
  const response = await client.post(
    "api/alignment_session/dimension_data/",
    params,
  );
  return response.data;
}
